export const environment = {
  production: false,
  api: 'http://4.201.147.199:8030/api',
  apiprotheus: 'http://4.201.147.199:8031/api',
  socketserver: 'http://4.201.147.199:8031',
  version: '1.0.0',
  timeout: 600, //600-seconds = 10minutos
  isDebugMode: false
}


